export { FooterMobile } from "./FooterMobile";
